import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { useUpdateMysteryChatStepMutation } from '~/features/chatRoom';
import {
  GuessingStep,
  MessageResponse,
  UpdateMysteryChatStepRequest,
} from '~/types';
import { breakpoint } from '~/styles/themes';
import '~/store';
import { useUserStore } from '~/store';
import Choices from './Choices/Choices';
import Guessing from './Guessing/Guessing';
import Introduction from './Introduction/Introduction';

interface ChatProps {
  webSocket: React.RefObject<WebSocket>;
  messages: MessageResponse[];
  setMessages: React.Dispatch<React.SetStateAction<MessageResponse[]>>;
  step: GuessingStep;
  setStep: React.Dispatch<React.SetStateAction<GuessingStep | null>>;
  waitingChat: boolean;
  handleSetWaitingChatTrue: () => void;
}

export default function Chat({
  webSocket,
  messages,
  setMessages,
  step,
  setStep,
  waitingChat,
  handleSetWaitingChatTrue,
}: ChatProps) {
  const { id } = useParams();
  const chatroom_id = id || '';
  const email = useUserStore((state) => state.email);
  // const { getStep, setStep } = useMysteryChatStore((state) => ({
  //   getStep: state.getStep,
  //   setStep: state.setStep,
  // }));

  const { mutate: stepMutate } = useUpdateMysteryChatStepMutation();

  const handleNextStep = (step: GuessingStep) => {
    const requestData: UpdateMysteryChatStepRequest = {
      chatroom_id,
      step,
    };
    // setStep(step);
    stepMutate(requestData, {
      onSuccess({ status }) {
        setStep(step);
      },
    });
  };

  const renderStep = (step: GuessingStep) => {
    switch (step) {
      case 'Introduction':
        return <Introduction onNextStep={handleNextStep} />;
      case 'Guessing':
        return (
          <Guessing
            webSocket={webSocket}
            messages={messages}
            setMessages={setMessages}
            waitingChat={waitingChat}
            handleSetWaitingChatTrue={handleSetWaitingChatTrue}
            onNextStep={handleNextStep}
          />
        );
      case 'Choices':
        return <Choices onNextStep={handleNextStep} />;
      default:
        return null;
    }
  };

  return (
    <Container>
      <Inner>{renderStep(step)}</Inner>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  position: absolute;
  z-index: 5;
  bottom: 0;
  left: 0;
  flex-direction: column;
  overflow: hidden;
  transition: height 0.1s ease-in-out;
`;

export const Inner = styled.div`
  display: block;
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  padding: 0 0 8px;
  transform: translateX(-50%);
`;
